// The 2.0 UI icon set (P3-03), from the P3-20 round 2 canvas (IconSet board):
// 24 px grid, 2 px inset, stroke only with round caps and joins, drawn in the
// current text colour. Stroke 1.6 at 16 px, 1.7 at 20, 1.8 at 24. Status stays a
// dot plus a word, never an icon. chevron, signout, collapse, sun, moon and auto are drawn here in the
// same grammar (the canvas had no theme or disclosure icons). settings is an
// 8-tooth gear (owner pick, 2026-10-25), matching iOS's SF gearshape.

import type { SVGProps } from 'react';

export const ICON_PATHS = {
  // Navigation
  triage: 'M4 13l2.5-8h11L20 13v6H4zM4 13h5l1 2h4l1-2h5',
  ideas: 'M9 6h11M9 12h11M9 18h11M4.5 6h.01M4.5 12h.01M4.5 18h.01',
  board: 'M4 4h16v16H4zM9.3 4v16M14.7 4v16',
  map: 'M6 7a2 2 0 1 0 0-.01M18 9a2 2 0 1 0 0-.01M12 19a2 2 0 1 0 0-.01M8 7.3l8 1.4M7 9l4 8M17 11l-4 6',
  dupes: 'M4 6h10v10H4zM10 10h10v10H10z',
  timeline: 'M4 6h7M4 12h12M4 18h5M13 4v4M19 10v4M11 16v4',
  archive: 'M3 5h18v4H3zM5 9v10h14V9M10 13h4',
  settings: 'M10.26 5.01L10.44 2.63L13.56 2.63L13.74 5.01A7.2 7.2 0 0 1 15.71 5.83L17.52 4.27L19.73 6.48L18.17 8.29A7.2 7.2 0 0 1 18.99 10.26L21.37 10.44L21.37 13.56L18.99 13.74A7.2 7.2 0 0 1 18.17 15.71L19.73 17.52L17.52 19.73L15.71 18.17A7.2 7.2 0 0 1 13.74 18.99L13.56 21.37L10.44 21.37L10.26 18.99A7.2 7.2 0 0 1 8.29 18.17L6.48 19.73L4.27 17.52L5.83 15.71A7.2 7.2 0 0 1 5.01 13.74L2.63 13.56L2.63 10.44L5.01 10.26A7.2 7.2 0 0 1 5.83 8.29L4.27 6.48L6.48 4.27L8.29 5.83A7.2 7.2 0 0 1 10.26 5.01zM9 12a3 3 0 1 0 6 0a3 3 0 1 0 -6 0',
  search: 'M11 11m-6 0a6 6 0 1 0 12 0a6 6 0 1 0 -12 0M20 20l-4.5-4.5',
  add: 'M12 5v14M5 12h14',
  account: 'M12 12a4 4 0 1 0 0-8a4 4 0 0 0 0 8zM5 20a7 7 0 0 1 14 0',
  // Actions
  merge: 'M7 4v5a5 5 0 0 0 5 5a5 5 0 0 0 5-5V4M12 14v6M9 17l3 3 3-3',
  link: 'M10 14a4 4 0 0 0 5.66 0l3-3a4 4 0 0 0-5.66-5.66l-1 1M14 10a4 4 0 0 0-5.66 0l-3 3a4 4 0 0 0 5.66 5.66l1-1',
  unlink: 'M9.5 14.5l-1 1a3.5 3.5 0 0 1-5-5l1-1M14.5 9.5l1-1a3.5 3.5 0 0 1 5 5l-1 1M4 4l16 16',
  copy: 'M9 9h10v10H9zM5 15V5h10',
  external: 'M14 4h6v6M20 4l-9 9M18 14v6H4V6h6',
  edit: 'M4 20h4L19 9l-4-4L4 16zM13.5 6.5l4 4',
  spec: 'M6 3h9l4 4v14H6zM14 3v5h5M9 13h7M9 17h5',
  chat: 'M5 5h14v10H10l-4 4v-4H5z',
  restore: 'M3 5h18v4H3zM5 9v10h14V9M12 17v-5M9.5 14.5L12 12l2.5 2.5',
  delete: 'M4 7h16M10 11v6M14 11v6M6 7l1 13h10l1-13M9 7V4h6v3',
  undo: 'M9 14L4 9l5-5M4 9h10a6 6 0 0 1 0 12h-3',
  retry: 'M4 12a8 8 0 0 1 13.7-5.6L20 9M20 4v5h-5M20 12a8 8 0 0 1-13.7 5.6L4 15M4 20v-5h5',
  filter: 'M4 6h16M7 12h10M10 18h4',
  sort: 'M7 4v16M4 17l3 3 3-3M17 20V4M14 7l3-3 3 3',
  download: 'M12 4v11M7 10l5 5 5-5M5 20h14',
  key: 'M12 15a4 4 0 1 1-8 0a4 4 0 0 1 8 0zM11 12l8-8M16 7l2 2M19 4l1 1',
  close: 'M6 6l12 12M18 6L6 18',
  more: 'M6 12h.01M12 12h.01M18 12h.01',
  chevron: 'M9 6l6 6-6 6',
  signout: 'M14 4h5v16h-5M10 8l-4 4 4 4M6 12h10',
  collapse: 'M4 4h16v16H4zM9 4v16M15 9l-3 3 3 3',
  sun: 'M12 16a4 4 0 1 0 0-8a4 4 0 0 0 0 8zM12 3v2M12 19v2M3 12h2M19 12h2M5.6 5.6l1.4 1.4M17 17l1.4 1.4M5.6 18.4L7 17M17 7l1.4-1.4',
  moon: 'M20 14.5A8 8 0 0 1 9.5 4a8 8 0 1 0 10.5 10.5z',
  auto: 'M12 20a8 8 0 1 0 0-16a8 8 0 0 0 0 16zM12 4v16',
  // Sources (all eight IDEA_SOURCES)
  mcp: 'M9 3v5M15 3v5M6 8h12v3a6 6 0 0 1-12 0zM12 17v4',
  voice: 'M4 12h.01M8 9v6M12 5v14M16 8v8M20 11v2',
  shortcut: 'M13 3L5 14h6l-1 7 8-11h-6z',
  ios: 'M7 3h10v18H7zM11 18h2',
  web: 'M3 5h18v14H3zM3 9h18M6 7h.01M9 7h.01',
  cli: 'M4 5h16v14H4zM8 10l3 2-3 2M13 15h4',
  repo: 'M6 3v12M18 9a3 3 0 1 0 0-6a3 3 0 0 0 0 6zM6 21a3 3 0 1 0 0-6a3 3 0 0 0 0 6zM18 9a9 9 0 0 1-9 9',
  email: 'M3 6h18v12H3zM3 7l9 6 9-6',
  api: 'M8 4H7a2 2 0 0 0-2 2v4l-2 2 2 2v4a2 2 0 0 0 2 2h1M16 4h1a2 2 0 0 1 2 2v4l2 2-2 2v4a2 2 0 0 1-2 2h-1',
} as const;

export type IconName = keyof typeof ICON_PATHS;

/** Idea source → icon (IDEA_SOURCES in shared). */
export const SOURCE_ICON: Record<string, IconName> = {
  'claude-mcp': 'mcp',
  siri: 'voice',
  shortcut: 'shortcut',
  ios: 'ios',
  web: 'web',
  cli: 'cli',
  email: 'email',
  api: 'api',
};

/** Stroke width for a rendered size (16 → 1.6, 20 → 1.7, 24 → 1.8); dots need a heavier stroke. */
function strokeFor(name: IconName, size: number): number {
  if (name === 'more') return 3;
  if (size <= 16) return 1.6;
  if (size <= 20) return 1.7;
  return 1.8;
}

export interface IconProps extends Omit<SVGProps<SVGSVGElement>, 'name'> {
  name: IconName;
  size?: number;
  /** Accessible name; without one the icon is decorative (aria-hidden). */
  label?: string;
}

export function Icon({ name, size = 16, label, ...rest }: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeFor(name, size)}
      strokeLinecap="round"
      strokeLinejoin="round"
      role={label ? 'img' : undefined}
      aria-label={label}
      aria-hidden={label ? undefined : true}
      focusable="false"
      {...rest}
    >
      <path d={ICON_PATHS[name]} />
    </svg>
  );
}
